var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlusWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.49996 2.66602C8.88416 2.66602 9.19561 2.97747 9.19561 3.36167V12.637C9.19561 13.0212 8.88416 13.3327 8.49996 13.3327C8.11576 13.3327 7.80431 13.0212 7.80431 12.637V3.36167C7.80431 2.97747 8.11576 2.66602 8.49996 2.66602Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8333 7.99935C13.8333 8.38355 13.5218 8.695 13.1376 8.695L3.86228 8.695C3.47808 8.695 3.16663 8.38355 3.16663 7.99935C3.16663 7.61515 3.47808 7.3037 3.86228 7.3037L13.1376 7.3037C13.5218 7.3037 13.8333 7.61515 13.8333 7.99935Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusWhite);
export default __webpack_public_path__ + "static/media/plus-white.ba851f3691b85331f46742c101b6ab93.svg";
export { ForwardRef as ReactComponent };